import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import Home from './pages/Home';
import InProgress from './pages/InProgress';
import GeoOS from './pages/GeoOS';
import Solutions from './pages/Solutions';
import Technology from './pages/Technology';
import PartnerProgram from './pages/PartnerProgram';
import Platform from './pages/Platform';
import AirfieldOperations from './pages/platform/AirfieldOperations';
import MaritimeOperations from './pages/platform/MaritimeOperations';
import Manifesto from './pages/Manifesto';
import ContactUs from './pages/ContactUs';

const GlobalStyle = createGlobalStyle`
  /* Scrollbar Styling */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: #000000;
    border-radius: 3px;
    width: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #333333;
  }

  /* For Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: #000000 rgba(255, 255, 255, 1.0);
  }
`;

const AppWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
`;

function App() {
  return (
    <AppWrapper>
      <GlobalStyle />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/geo-os" element={<GeoOS />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/partner-program" element={<PartnerProgram />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/platform/airfield-operations" element={<AirfieldOperations />} />
          <Route path="/platform/maritime-operations" element={<MaritimeOperations />} />
          <Route path="/manifesto" element={<Manifesto />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/careers" element={<InProgress />} />
          <Route path="*" element={<InProgress />} />
        </Routes>
      </Router>
    </AppWrapper>
  );
}

export default App; 